import React from "react";
import { SearchSelectDebounce } from "Components/SearchSelectDebounce/SearchSelectDebounce";
import { TeamOutlined } from "@ant-design/icons";
import { Space } from "antd";
import { getAllUsersToSelect } from "Api/UsersApi/helpers";

export const FiltersForAllProjects = ({ value, onChange }) => {
  return (
    <Space>
      <SearchSelectDebounce
        labelInValue={true}
        customFetch={getAllUsersToSelect}
        prefix={<TeamOutlined />}
        mode="multiple"
        type={"engineer"}
        placeholder="Пошук по інженеру"
        width={300}
        onChange={onChange}
        value={value}
      />
    </Space>
  );
};
